import { AppConfigContext } from '../common/services/AppConfigContext';
import { FeatureFlagsType, getFeatureFlag } from '../config/launch-darkly/FeatureFlagsController';
import { PATHS } from '../routing/routes';

export const UNAUTHORIZED_MESSAGES = [
  `You must supply an \`API-KEY\` header in your request`,
  `Invalid API key`,
  `Authorization Header must be set for OpenID-managed Authorization Claims`,
];

/**
 * Utility function to check whether the new AQueduct auth system is enabled based on multiple flags
 * @returns true if all flags are true
 */
export const isAqueductEnabled = () => {
  const idpAuthorization = getFeatureFlag(FeatureFlagsType.ENABLE_IDP_AUTHORIZATION);
  const userRoles = getFeatureFlag(FeatureFlagsType.ENABLE_ORGANIZATION_USER_ROLES);
  const tokenEndpoint = getFeatureFlag(FeatureFlagsType.ENABLE_OIDC_TOKEN_ENDPOINT);

  return Boolean(idpAuthorization && userRoles && tokenEndpoint);
};

export const getOptionalAuthHeader = (): Record<string, string> | null => {
  const useAqueduct = isAqueductEnabled();
  const token = AppConfigContext.getToken();
  if (!token) {
    return null;
  }
  return useAqueduct ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * We expect all routes to explicitly start with one / and then proper string.
 * With this sanitization, we are defending against manipulation of the next parameter
 * being anything besides a route for our page to handle.
 */
export const sanitizeNextUrl = (nextRoute: string): string => {
  if (!nextRoute.match(/^\/[a-z]/gi)) {
    return PATHS.ORGANIZATION_DASHBOARD;
  }

  return nextRoute;
};
